<div class="w-full flex flex-col mt-6">
    <p class="w-full text-center mb-4">Font Size: {{fontSize}}px</p>
    <p-slider [(ngModel)]="fontSize" [step]="2" styleClass="w-full" [min]="10" [max]="20" (onSlideEnd)="changeBaseFontSize($event)"/>
</div>

